import {
  GET_PAYMENT_METHODS,
  GET_PAYMENT_METHODS_SUCCESS,
  GET_PAYMENT_METHODS_ERROR,
  INITIATE_CARD_UPDATE,
  INITIATE_CARD_UPDATE_SUCCESS,
  INITIATE_CARD_UPDATE_ERROR,
  COMPLETE_CARD_UPDATE,
  COMPLETE_CARD_UPDATE_SUCCESS,
  COMPLETE_CARD_UPDATE_ERROR,
  GET_BILLING_REPORT,
  GET_BILLING_REPORT_SUCCESS,
  GET_BILLING_REPORT_ERROR,
  CANCEL_CARD_UPDATE,
  CANCEL_CARD_UPDATE_SUCCESS,
  CANCEL_CARD_UPDATE_ERROR,
  COMPLETE_CARD_UPDATE_2,
  COMPLETE_CARD_UPDATE_2_SUCCESS,
  COMPLETE_CARD_UPDATE_2_ERROR,
} from './actionTypes';

const INIT_STATE = {
  payment_methods: [],
  error: null,
  loading: false,
  loading_report: false,
  updating_card: false,

};
function PaymentMethods(state = INIT_STATE, action) {
  switch (action.type) {
    case GET_PAYMENT_METHODS:
      return {
        ...state,
        error: null,
        loading: true,
        updating_card: false,

      };

    case GET_PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        error: null,
        payment_methods: action.payload,
        loading: false,
        updating_card: false,

      };

    case GET_PAYMENT_METHODS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        updating_card: false,

      };
    case INITIATE_CARD_UPDATE:
      return {
        ...state,
        loading: true,
        updating_card: false,

      };
    case INITIATE_CARD_UPDATE_SUCCESS:
      return {
        ...state,
        payment_methods: action.payload,
        loading: false,
        updating_card: false,

      };
    case INITIATE_CARD_UPDATE_ERROR:
      return {
        ...state,
        loading: false,
        updating_card: false,

      };
    case COMPLETE_CARD_UPDATE:
      return {
        ...state,
        loading: true,
        updating_card: true,

      };
    case COMPLETE_CARD_UPDATE_SUCCESS:
      return {
        ...state,
        payment_methods: action.payload,
        loading: false,
        updating_card: false,

      };
    case COMPLETE_CARD_UPDATE_ERROR:
      return {
        ...state,
        loading: false,
        updating_card: false,

      };
      case COMPLETE_CARD_UPDATE_2:
        return {
          ...state,
          loading: true,
          updating_card: false,

        };
      case COMPLETE_CARD_UPDATE_2_SUCCESS:
        return {
          ...state,
          payment_methods: action.payload,
          loading: false,
          updating_card: false,

        };
      case COMPLETE_CARD_UPDATE_2_ERROR:
        return {
          ...state,
          loading: false,
          updating_card: false,

        };
    case GET_BILLING_REPORT:
      return {
        ...state,
        error: null,
        loading_report: true,
        updating_card: false,

      };

    case GET_BILLING_REPORT_SUCCESS:
      return {
        ...state,
        error: null,
        loading_report: false,
        updating_card: false,

      };

    case GET_BILLING_REPORT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading_report: false,
        updating_card: false,

      };
    case CANCEL_CARD_UPDATE:
      return {
        ...state,
        loading: true,
        updating_card: false,

      };
    case CANCEL_CARD_UPDATE_SUCCESS:
      return {
        ...state,
        payment_methods: action.payload,
        loading: false,
        updating_card: false,

      };
    case CANCEL_CARD_UPDATE_ERROR:
      return {
        ...state,
        loading: false,
        updating_card: false,

      };

    default:
      return state;
  }
}

export default PaymentMethods;
